import React, { useState } from 'react';
import './SmartContracts.css';

const SmartContracts = ({ onNext }) => {
  const [notes, setNotes] = useState('');

  const handleProceed = () => {
    alert('✅ Proceeding to marketplace...');
    if (onNext) {
      onNext();
    }
  };

  return (
    <div className="smart-contracts">
      <header className="smart-contracts-header">
        <h1>Smart Contracts</h1>
        <p>Automated Token Management</p>
      </header>

      <div className="smart-contracts-container">
        {/* Tokenization Status */}
        <section className="smart-contracts-section">
          <div className="smart-contracts-section-header">Tokenization Status</div>
          <div className="tokenization-display">
            <div className="token-icon">🪙</div>
            <div className="token-amount">2.3</div>
            <div className="token-label">Carbon Credit Tokens</div>
            <div className="token-status">100 tokens minted</div>
          </div>
        </section>

        {/* Token Information */}
        <section className="smart-contracts-section">
          <div className="smart-contracts-section-header">Token Information</div>
          <div className="token-info-grid">
            <div className="token-info-item">
              <span>Token Name:</span>
              <strong>Blue Carbon Credit</strong>
            </div>
            <div className="token-info-item">
              <span>Token Symbol:</span>
              <strong>BCC</strong>
            </div>
            <div className="token-info-item">
              <span>Token Standard:</span>
              <strong>ERC-20</strong>
            </div>
            <div className="token-info-item">
              <span>Total Supply:</span>
              <strong>100 BCC</strong>
            </div>
          </div>
        </section>

        {/* Contract Details */}
        <section className="smart-contracts-section">
          <div className="smart-contracts-section-header">Contract Details</div>
          <div className="contract-details-grid">
            <div className="contract-detail-item">
              <span>Contract Address:</span>
              <code>0x1A2B3C...4D5E6F</code>
            </div>
            <div className="contract-detail-item">
              <span>Deployment Date:</span>
              <strong>15/10/2023</strong>
            </div>
            <div className="contract-detail-item">
              <span>Gas Used:</span>
              <strong>245,678</strong>
            </div>
          </div>
        </section>

        {/* Access Functions */}
        <section className="smart-contracts-section">
          <div className="smart-contracts-section-header">Access Functions</div>
          <div className="functions-list">
            <div className="function-item">
              <span className="function-icon">⚙️</span>
              <span className="function-name">transfer(address, amount)</span>
            </div>
            <div className="function-item">
              <span className="function-icon">⚙️</span>
              <span className="function-name">approve(spender, amount)</span>
            </div>
            <div className="function-item">
              <span className="function-icon">⚙️</span>
              <span className="function-name">retire(amount)</span>
            </div>
            <div className="function-item">
              <span className="function-icon">⚙️</span>
              <span className="function-name">balanceOf(address)</span>
            </div>
          </div>
        </section>

        {/* Contract Verification */}
        <section className="smart-contracts-section">
          <div className="smart-contracts-section-header">Contract Verification</div>
          <div className="verification-status">
            <div className="verification-item">
              <span className="verification-icon">✓</span>
              <span>Source code verified</span>
            </div>
            <div className="verification-item">
              <span className="verification-icon">✓</span>
              <span>Security audit passed</span>
            </div>
            <div className="verification-item">
              <span className="verification-icon">✓</span>
              <span>Compliance checks completed</span>
            </div>
          </div>
        </section>

        {/* Contract Notes */}
        <section className="smart-contracts-section">
          <div className="smart-contracts-section-header">Contract Notes</div>
          <textarea
            className="smart-contracts-textarea"
            placeholder="Add any notes about the smart contract..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </section>

        {/* Action Button */}
        <div className="smart-contracts-actions">
          <button className="smart-contracts-btn proceed-btn" onClick={handleProceed}>
            Proceed to Marketplace
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmartContracts;
